<template>
<!-- 首页 -->
  <div class="home">
    <div class="item banner" >
      <img class="item-img"  src="https://qiniu.swarma.org/business/jpg/home/banner.png" alt="集智学园">
    </div>
    <div class="item"  style="cursor: pointer" @click="toRouter(item.name)" v-for="(item,i) in picList"  :key="i">
      <img class="item-img" :src="item.src" alt="集智学园">
      <div class="item-text">
        <h1 class="item-title" :style="{color:item.titleColor}">{{item.title}}</h1>
        <div class="item-content" :style="{color:item.contentColor}">{{item.content}}</div>
        <span class="item-content campus home-btn" :style="{background:item.buttonColor, color:item.titleColor}"><a>前往{{item.title}}</a></span>
      </div>
    </div>
    <div class="item">
      <img class="item-img"  src="https://qiniu.swarma.org/business/jpg/home/bg_shouye5.png" alt="集智学园">
      <div class="footer-item-text item-text">
      <h1 class="title">联系我们</h1>
      <span class="text">电话：010-62937699</span>
      <span class="text">微信：15011537754</span>
      <span class="text">邮箱：wangchaohui@swarma.org</span>
      <span class="text">集智学园QQ群：426390994</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'home',
  data () {
    return {
      picList: [{
        name: 'swarma',
        title: '集智学园',
        titleColor: '#fff',
        content: '集智学园成立于2016年，是一个专注于复杂系统&人工智能的知识服务社区。主要面向技术类高管、高级工程师、科研人员、在校大学生提供人工智能、机器学习、大数据、复杂系统等领域的系列讲解课程及定制咨询服务。',
        contentColor: '#BDFFF0',
        buttonColor: 'rgb(9, 164, 139)',
        src: 'https://qiniu.swarma.org/business/jpg/home/bg_shouye1.png'
      }, {
        name: 'training',
        title: '企业培训',
        titleColor: '#0069E3',
        content: '集智学园企业培训主要面向企业管理者、中高级技术人员、工程师，针对不同行业及企业的需求提供人工智能、机器学习、大数据、复杂系统等领域的系列讲解课程和定制化的企业咨询服务。',
        contentColor: '#333',
        buttonColor: 'rgb(236, 236, 236)',
        src: 'https://qiniu.swarma.org/business/jpg/home/bg_shouye2.png'
      }, {
        name: 'teacher',
        title: '讲师团队',
        titleColor: '#fff',
        content: '讲师全部来自人工智能科研、创业的第一线。集智学园讲师有中科院、清华、北大、北师大等名校的老师，也有国内一线人工智能公司的业内专家。',
        contentColor: '#8EC4FF',
        buttonColor: '#084e9c',
        src: 'https://qiniu.swarma.org/business/jpg/home/bg_shouye3.png'
      }, {
        name: 'advisory',
        title: '企业咨询',
        titleColor: '#0036D1 ',
        content: '集智学园咨询服务根据上市公司的已有数据，利用大数据分析等方法对公司进行分析，设计衡量公司发展的评价体系和定量指标，对公司发展情况进行深度检查，同时给出分析报告，让企业向着更加积极地方向发展。',
        contentColor: '#333',
        buttonColor: '#fff',
        src: 'https://qiniu.swarma.org/business/jpg/home/bg_shouye4.png'
      }]
    }
  },
  methods: {
    toRouter (name) {
      if (name === 'swarma') {
        window.open('https://campus.swarma.org')
        return
      }
      this.$router.push({
        name: name
      })
    }
  }
}
</script>
<style lang="less" scoped>
.item {
  position: relative;
  .item-img {
    height: 100%;
    margin: 0;
    display: inherit;
  }
  .item-text {
    position: absolute;
    padding: 0 20%;
    box-sizing: border-box;
    color: #fff;
    top: 50%;
    font-size: 16px;
    transform: translateY(-50%);
    line-height: 28px;
    .item-title {
      font-weight: normal;
      font-size: 42px;
      height: 80px;
      line-height: 80px;
      margin: 10px 0;
    }
    .item-content {
      width: 55%;
      min-width: 450px;
      margin-bottom: 20px;
      &.home-btn {
        padding: 8px 13px;
        // display: inline-block;
        min-width: inherit;
        margin-top: 20px;
        border-radius: 3px;
        box-shadow: 0 0 1px 1px rgba(0, 0, 0, 0.1);
      }
      // &:type
    }
  }
  .footer-item-text {
    left: 0;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    text-align: center;
    color: #fff;
    padding: 5%;
    box-sizing: border-box;
    width: 100%;
    h1.title {
      color: #fff;
    }
    .text {
      width: 25%;
    }
  }
}
// 平板
@media screen and(max-width: 769px) {
.item {
    overflow: hidden;
    &.banner {
      .item-img {
        height: inherit;
        width: 100%;
      }
    }
    .item-img {
      height: 80%;
      margin: 0;
      display: inherit;
      width: 350%;
    }
    .item-text {
      position: absolute;
      padding: 0 20%;
      color: #fff;
      // top: 0;
      font-size: 12px;
      line-height: 20px;
      .item-title {
        font-weight: normal;
        font-size: 18px;
        height: 47px;
        line-height: 63px;
        margin: 10px 0;
      }
      .item-content {
        width: inherit;
        min-width: inherit;
      }
    }
    .footer-item-text {
      h1.title {
        color: #fff;
        height: 24px
      }
      .text {
        width: 50%;
      }
    }
  }
}
// 移动
@media screen and(max-width: 414px) {
  .item {
    .item-img:last-child{
      // width: 300%;
    }
    .footer-item-text {
      .text {
        width: 100%;
      }
    }
    .item-text {
      .item-content.mobileNone {
        display: none;
      }
    }
  }
}
</style>
